/**
 * @Description: Header公共头组件
 * @Author: huping
 * @Date: 2021-08-06 10:54:02
 * @LastEditTime: 2022-06-16 11:31:01
 */

<template>
  <div class="header flex-row flex-center" :class="{'collapse-menu': isMenuCollapse}" :data-collapse="menuCollapse">
    <!-- <div class="collapse-btn flex-row flex-center" @click="collapseSwitch">
      <i
        v-if="isMenuCollapse"
        class="newhope-iconfont icon-base-exmenu"
      ></i>
      <i
        v-else
        class="newhope-iconfont icon-base-packmenu"
      ></i>
    </div> -->
    <nav-bread class="header-breadcrumb" />
    <div class="header-nav flex-row flex-item flex1">
      <!-- <div class="header-nav-btn flex-column"
           :class="{active: activeType === btn.value}"
           @click="btnClick(btn)"
           v-for="btn in navBtns" :key="btn.value">
        <div class="flex1"></div>
        <p>{{btn.name}}</p>
        <div class="flex1"></div>
        <div class="bottom-line"></div>
      </div> -->
      <div class="flex1"></div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { getStorage, setStorage } from '@utils/storage';
import loginApi from '@/api/login';
import NavBread from './system/NavBread.vue';

export default {
  name: 'nhHeader',
  components: {
    NavBread,
  },
  data() {
    return {
      nodeEnv: process.env.NODE_ENV,
      navBtns: [
        {
          name: 'IoT数据应用中台',
          value: 'iot',
        },
        {
          name: 'UED示例',
          value: 'business',
        },
        {
          name: '开发示例',
          value: 'development',
        },
      ],
      activeType: '',
    };
  },
  computed: {
    ...mapState('systemMenu', ['tabList', 'activeTab', 'menuList', 'navModel', 'menuCollapse']),
    isMenuCollapse() {
      return this.menuCollapse === 'collapse';
    }
  },
  methods: {
    ...mapActions('systemMenu', ['doSwitchTab', 'updateMenuList']),
    btnClick(item) {
      this.activeType = item.value;
      setStorage('left-menu-type', item.value);
      this.updateMenuList(item.value);
      this.$store.commit('systemMenu/updateTabList', []);
      this.doSwitchTab(null);
    },
    toHome() {
      this.$router.replace('/device/device/index');
    },
    collapseSwitch() {
      const newCollapse = this.menuCollapse === 'expand' ? 'collapse' : 'expand';
      this.$store.commit('systemMenu/updateMenuCollapse', newCollapse);
      setStorage('nav-menu-collapse', newCollapse);
    },
    getUserInfo() {
      this.loading = true;
      loginApi
        .getInfo()
        .then((res) => {
          this.$store.commit('userInfo/baseInfo', res);
        })
        .catch((err) => {
          this.$message({
            message: err.message || '获取用户失败，请重新登录！',
            type: 'error',
            showClose: true,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  mounted() {
    this.activeType = getStorage('left-menu-type') || this.navBtns[0].value;
    this.getUserInfo();
    // 初始化菜单折叠状态
    const storedCollapse = getStorage('nav-menu-collapse') || 'expand';
    this.$store.commit('systemMenu/updateMenuCollapse', storedCollapse);
  },
  beforeDestroy() {
  },
};
</script>

<style scoped lang='scss'>
.header {
  width: calc(100% - 207px);
  height: 48px;
  background: #fff;
  position: absolute;
  top: 5px;
  left: 200px;
  display: flex;
  z-index: 100;
  transition: all 0.5s;
  border-bottom: 1px solid #e4e4e7;
  border-radius: 8px 8px 0 0;
  border-right: 1px solid #e4e4e7;
  border-left: 1px solid #e4e4e7;
  border-top: 1px solid #e4e4e7;
  &.collapse-menu {
    width: calc(100% - 48px);
    left: 40px;
  }

  .collapse-btn {
    width: 40px;
    height: 48px;
    cursor: pointer;
    font-size: 16px;
    color: #666;
    transition: all 0.3s;

    &:hover {
      color: $primary;
    }

    i {
      font-size: 16px;
    }
  }

  .header-breadcrumb {
    background-color: transparent;
    padding: 0;
    margin-right: 16px;
    padding-left: 16px;
    display: flex;
    align-items: center;
    height: 48px;
    line-height: 48px;
  }

  .header-nav {
    text-align: center;
    height: 100%;
    .header-nav-btn {
      cursor: pointer;
      height: 100%;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: #000000;
      margin-left: 72px;
      .bottom-line {
        height: 2px;
        background-color: $primary;
        opacity: 0;
      }
      &.active {
        color: $primary;
        .bottom-line {
          opacity: 1;
        }
      }
    }

  }
}
</style>
